import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class LanguagesFetchAPI {

    static async getLanguages( token) {
        const res = await server(`/languages`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }


}

